var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"text-2xl text-ultramarine",class:_vm.iconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }